export const REGISTER_ADMIN = "REGISTER_ADMIN";
export const REGISTER_ADMIN_SUCCESS = "REGISTER_ADMIN_SUCCESS";
export const REGISTER_ADMIN_FAIL = "REGISTER_ADMIN_FAIL";
